import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from "@angular/common/http";
import { inject, Injector, runInInjectionContext } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { e2eTokenStorageKey } from "../consts/storage-keys";
import { EnvironmentId } from "../enums/environment-id.enum";
import { msalInterceptor } from "./msal.interceptor";

export const appHttpInterceptor: HttpInterceptorFn = (request: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
  const injector = inject(Injector);
  const e2eToken = sessionStorage.getItem(e2eTokenStorageKey);

  if (request.url.includes("assets/release_notes/") || request.url.includes("assets/i18n/")) {
    request = request.clone({
      headers: request.headers /**/
        .set("Cache-Control", "no-cache, no-store, must-revalidate")
        .set("Pragma", "no-cache")
        .set("Expires", "0"),
    });
  }

  if (environment.id !== EnvironmentId.Production && e2eToken) {
    if (request.url.includes(environment.apiBaseUrl)) {
      return next(
        request.clone({
          withCredentials: true,
          headers: request.headers.set("Authorization", `Bearer ${e2eToken}`),
        })
      );
    } else {
      return next(request);
    }
  }

  return runInInjectionContext(injector, () => msalInterceptor(request, next));
};
